module.exports = __webpack_public_path__ + "img/background_active_img_three.17eea944.png";